export const DEFAULT_STATUS_COLOR = "text-gray-600 bg-gray-50 border-gray-200";

export const STATUS_COLORS: Record<string, string> = {
  created: DEFAULT_STATUS_COLOR,
  in_process: "text-blue-600 bg-blue-50 border-blue-200",
  in_validation: "text-yellow-600 bg-yellow-50 border-yellow-200",
  done: "text-green-600 bg-green-50 border-green-200",
} as const;
